import { styled } from '@cp/ds/src/theme';

export const CatalogList = styled('ul', { name: 'CatalogList', slot: 'root' })({
  listStyle: 'none',
  padding: 0,
  marginBlockStart: 0,
  marginBlockEnd: 0,
});

export const CatalogListItem = styled('li', { name: 'CatalogList', slot: 'item' })({
  padding: 0,
  display: 'flex',
});
